import React, { useEffect, useState, useContext, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import TableReport from "../Components/TableReport";
import { APIServices } from "../helpers/APIServices";
import dayjs from "dayjs";
import LineChart from "../Components/LineChart";
import DateTime from "../Components/DateTime";
import Button from "@mui/material/Button";
import { UserContext } from "../Layout";
import TableControlLimit from "../Components/TableControlLimit";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import SimpleBackdrop from "../Components/Backdrop";
import Download from "@mui/icons-material/Download";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { injectImageIfPlaceholderExists, getImageUrl } from "../helpers/common";
const headers = [
  // {
  //   name: "id",
  // },
  {
    name: "No.",
  },
  {
    name: "create date",
  },
  {
    name: "M/C",
  },
  {
    name: "actual",
    col: [
      {
        name: "No.1",
      },
      {
        name: "No.2",
      },
      {
        name: "No.3",
      },
    ],
  },
  // {
  //   name: "answer",
  //   col: [
  //     {
  //       name: "No.1",
  //     },
  //     {
  //       name: "No.2",
  //     },
  //     {
  //       name: "No.3",
  //     },
  //   ],
  // },
  {
    name: "average",
  },
  {
    name: "range",
  },
  {
    name: "inspector",
  },
  {
    name: "reviewer",
  },
];

const controlLimit = [
  {
    name: "categories",
    col: [
      {
        name: "UCL",
      },
      {
        name: "CL",
      },
      {
        name: "LCL",
      },
    ],
  },
];

const PerPath = () => {
  const defaultDateTime = {
    start: `${dayjs().subtract(1, "d").format("YYYY-MM-DD")} 00:00:00`,
    end: `${dayjs().format("YYYY-MM-DD")} 23:59:59`,
  };
  const params = useParams();
  const [reportData, setReportData] = useState([]);
  const [dataAverage, setDataAverage] = useState([]);
  const [dataRange, setDataRange] = useState([]);
  const [startDate, setStartDate] = useState({
    error: false,
    value: defaultDateTime.start,
  });
  const [endDate, setEndDate] = useState({
    error: false,
    value: defaultDateTime.end,
  });
  const [loading, setLoading] = useState(false);

  const [checkDate, setCheckDate] = useState({
    error: false,
    message: "end date should more than start date",
  });
  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelecteds = reportData.slice(0, 30).map((n) => n.id);
      setSelectedRows(newSelecteds);
      return;
    }
    setSelectedRows([]);
  };

  const handleSelectFirst30 = () => {
    const newSelecteds = reportData.slice(0, 30).map((n) => n.id);
    setSelectedRows(newSelecteds);
  };

  const handleSelectRow = (event, id) => {
    const selectedIndex = selectedRows.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      if (selectedRows.length >= 30) {
        alert("สามารถเลือกข้อมูลเพื่อ Export ได้สูงสุด 30 รายการเท่านั้น");
        return;
      }
      newSelected = newSelected.concat(selectedRows, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedRows.slice(1));
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelected = newSelected.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1),
      );
    }

    setSelectedRows(newSelected);
  };
  const [xBar, setXBar] = useState();
  const [rChart, setRChart] = useState([]);
  const [part, setPart] = useState({});
  const [question, setQuestion] = useState({});
  const chartRef = useRef(null);
  const d2neq3 = 1.693;
  let location = useLocation();
  let locationArr = location.pathname.split("/").reverse();
  const user = useContext(UserContext);

  const findOnePart = async (startDate, endDate) => {
    if (!startDate && !endDate) {
      startDate = defaultDateTime.start;
      endDate = defaultDateTime.end;
    }
    setLoading(true);
    try {
      const partId = locationArr[4];
      const questionParamId = params.id;

      const [responseFromFindOnePart, responseQuestion] = await Promise.all([
        APIServices.findOnePart(partId),
        APIServices.findOneQuestion(questionParamId),
      ]);

      const resultFromFindOnePart = responseFromFindOnePart?.data;
      const questions = responseQuestion?.data?.data;
      const qAttrs = questions?.attributes || {};

      const formatLimit = (val) => {
        if (val === undefined || val === null || val === "" || isNaN(Number(val))) {
          return "-";
        }
        return Number(val).toFixed(3);
      };

      let questionSC = {
        question_name: qAttrs.question || "-",
        spec_min:
          qAttrs.spec_min !== undefined &&
          qAttrs.spec_min !== null &&
          !isNaN(Number(qAttrs.spec_min))
            ? Number(qAttrs.spec_min)
            : undefined,
        spec_max:
          qAttrs.spec_max !== undefined &&
          qAttrs.spec_max !== null &&
          !isNaN(Number(qAttrs.spec_max))
            ? Number(qAttrs.spec_max)
            : undefined,
        CL_Rchart: formatLimit(qAttrs.CL_Rchart),
        LCL_Rchart: formatLimit(qAttrs.LCL_Rchart),
        UCL_Rchart: formatLimit(qAttrs.UCL_Rchart),
        CL_Xbar: formatLimit(qAttrs.CL_Xbar),
        LCL_Xbar: formatLimit(qAttrs.LCL_Xbar),
        UCL_Xbar: formatLimit(qAttrs.UCL_Xbar),
      };

      if (resultFromFindOnePart?.data) {
        const partData = resultFromFindOnePart.data;
        let image = "";
        if (partData?.attributes?.image?.data?.attributes?.url) {
          image = partData.attributes.image.data.attributes.url;
        } else if (partData?.attributes?.image?.data?.[0]?.attributes?.url) {
          image = partData.attributes.image.data[0].attributes.url;
        } else if (partData?.attributes?.image?.url) {
          image = partData.attributes.image.url;
        } else if (
          Array.isArray(partData?.attributes?.image) &&
          partData.attributes.image[0]?.url
        ) {
          image = partData.attributes.image[0].url;
        }

        setPart({
          part_name: partData.attributes?.part_name || "",
          part_code: partData.attributes?.part_code || "",
          part_image: image,
          customer: partData.attributes?.customer || "",
          ...questionSC,
        });
        setXBar({
          UCL: questionSC.UCL_Xbar,
          CL: questionSC.CL_Xbar,
          LCL: questionSC.LCL_Xbar,
        });
        setRChart({
          UCL: questionSC.UCL_Rchart,
          CL: questionSC.CL_Rchart,
          LCL: questionSC.LCL_Rchart,
        });
      }

      const response = await APIServices.getPaper(
        startDate,
        endDate,
        partId,
        user,
      );
      const result = response?.data;
      if (result?.data) {
        const papers = result.data;
        let report = [];
        const arrAverage = [];
        const arrRange = [];
        let questionId;

        papers.forEach((paper) => {
          try {
            let realSC,
              average = 0,
              range = 0;

            const sub_categories = Array.isArray(
              paper?.attributes?.answer?.sub_categories,
            )
              ? paper.attributes.answer.sub_categories
              : [];

            let isSkip = false;
            sub_categories.forEach((sub_category) => {
              const questionsList = Array.isArray(sub_category?.questions)
                ? sub_category.questions
                : [];
              const SC = questionsList.find(
                (q) => q.questionId === parseInt(locationArr[0]),
              );
              if (SC) {
                if (SC.skipQuestion) {
                  isSkip = true;
                  return;
                }
                if (!realSC) {
                  realSC = SC;
                  if (!questionId) {
                    questionId = SC.questionId;
                  }
                  if (Array.isArray(SC.actual) && SC.actual.length > 0) {
                    const actualInt = SC.actual
                      .map((val) => parseFloat(val))
                      .filter((val) => !isNaN(val));

                    if (actualInt.length > 0) {
                      const sumActual = actualInt.reduce((a, b) => a + b, 0);
                      average = parseFloat(
                        (sumActual / actualInt.length).toFixed(2),
                      );
                      const min = Math.min(...actualInt);
                      const max = Math.max(...actualInt);
                      range = max - min;
                    }
                  }
                }
              }
            });

            if (isSkip) {
              return;
            }

            const inspector =
              paper.attributes?.inspector_id?.data?.attributes?.name || "-";
            const checker =
              paper.attributes?.checker_id?.data?.attributes?.name || "-";

            if (realSC !== undefined) {
              report.push({
                id: paper.id,
                createAt: dayjs(paper.attributes?.createdAt).format(
                  "YYYY-MM-DD HH:mm:ss",
                ),
                shift: paper.attributes?.shift || "",
                sc: realSC,
                average: average,
                range: range.toFixed(2),
                inspector: inspector,
                checker: checker,
                statusDelete: paper.attributes?.delete,
                jobNo: paper.attributes?.jobNumber || "",
                date: paper.attributes?.date || "",
                time: paper.attributes?.time || "",
                machineNo: paper.attributes?.machineNumber || "",
              });
              if (!isNaN(average)) {
                arrAverage.push(average);
                arrRange.push(range);
              }
            }
          } catch (paperError) {
            console.error("Error processing paper:", paperError);
          }
        });

        setReportData(report);
        setDataAverage(arrAverage);
        setDataRange(arrRange);
        if (questionId) {
          getQuestionByID(questionId);
        }
      }
    } catch (error) {
      console.error("Error fetching data in PerPath:", error);
    } finally {
      setLoading(false);
    }
  };

  const getQuestionByID = async (questionId) => {
    if (!questionId) {
      return;
    }
    try {
      const response = await APIServices.findOneQuestion(questionId);
      const result = response?.data;
      if (result?.data) {
        const question = result.data;
        setQuestion(question.attributes || {});
      }
    } catch (err) {
      console.error("Error in getQuestionByID:", err);
    }
  };

  const handleOnChangeStartDate = (date, time) => {
    if (!date || !time) {
      setStartDate((prev) => ({
        ...prev,
        value: undefined,
      }));
      return;
    }
    const startDate = dayjs(`${date} ${time}`).format("YYYY-MM-DD HH:mm:ss");
    setStartDate((prev) => ({
      ...prev,
      value: startDate,
      error: false,
    }));
  };

  const handleOnChangeEndDate = (date, time) => {
    if (!date || !time) {
      setEndDate((prev) => ({
        ...prev,
        value: undefined,
      }));
      return;
    }
    const endDate = dayjs(`${date} ${time}`).format("YYYY-MM-DD HH:mm:ss");
    setEndDate((prev) => ({
      ...prev,
      value: endDate,
      error: false,
    }));
  };

  const handleSubmitSearch = async (startDate, endDate) => {
    if (!startDate.value) {
      setStartDate((prev) => ({
        ...prev,
        error: true,
      }));
      return;
    }
    if (!endDate.value) {
      setEndDate((prev) => ({
        ...prev,
        error: true,
      }));
      return;
    }

    if (
      dayjs(endDate.value).isBefore(startDate.value, "minute") ||
      dayjs(endDate.value).isSame(startDate.value, "minute")
    ) {
      setCheckDate((prev) => ({
        ...prev,
        error: true,
      }));
      setTimeout(() => {
        setCheckDate((prev) => ({
          ...prev,
          error: false,
        }));
      }, 2000);
      return;
    }
    setLoading(true);
    await findOnePart(startDate.value, endDate.value);
  };

  const calX = (arrayAverage) => {
    if (Array.isArray(arrayAverage)) {
      if (arrayAverage.length === 0) {
        return 0;
      }
      const sum = arrayAverage.reduce((prev, current) => prev + current, 0);
      return sum / arrayAverage.length;
    }
    return 0;
  };

  const calR = (arrayRange) => {
    if (Array.isArray(arrayRange)) {
      if (arrayRange.length === 0) {
        return 0;
      }
      const sum = arrayRange.reduce((prev, current) => prev + current, 0);
      return sum / arrayRange.length;
    }
    return 0;
  };

  const calSigma = (dataRange, d2neq3) => {
    if (!d2neq3 || d2neq3 === 0) return 0;
    const R = calR(dataRange);
    const sigma = R / d2neq3;
    return sigma;
  };

  const calCP = (max, min, dataRange, d2neq3) => {
    if (
      max === undefined ||
      min === undefined ||
      max === null ||
      min === null
    ) {
      return 0;
    }
    const numMax = Number(max);
    const numMin = Number(min);
    if (isNaN(numMax) || isNaN(numMin)) return 0;
    const maxSubMin = numMax - numMin;
    const R = calR(dataRange);
    if (!R || !d2neq3) return 0;
    const CP = maxSubMin / (parseFloat(R / d2neq3) * 6);
    return isFinite(CP) ? CP : 0;
  };

  const calCPU = (max, dataAverage, dataRange, d2neq3) => {
    if (max === undefined || max === null || isNaN(Number(max))) return 0;
    const numMax = Number(max);
    const X = calX(dataAverage);
    const R = calR(dataRange);
    if (!R || !d2neq3) return 0;
    const denom = 3 * (R / d2neq3);
    if (!denom) return 0;
    const CPU = (numMax - X) / denom;
    return isFinite(CPU) ? CPU : 0;
  };

  const calCPL = (dataAverage, min, dataRange, d2neq3) => {
    if (min === undefined || min === null || isNaN(Number(min))) return 0;
    const numMin = Number(min);
    const X = calX(dataAverage);
    const sigma = calSigma(dataRange, d2neq3);
    if (!sigma) return 0;
    const CPL = (X - numMin) / (3 * sigma);
    return isFinite(CPL) ? CPL : 0;
  };

  const calCPK = (CPU, CPL) => {
    const numCPU = typeof CPU === "number" ? CPU : parseFloat(CPU);
    const numCPL = typeof CPL === "number" ? CPL : parseFloat(CPL);
    if (
      isNaN(numCPU) ||
      isNaN(numCPL) ||
      !isFinite(numCPU) ||
      !isFinite(numCPL)
    ) {
      return "-";
    }
    if (numCPU < numCPL) {
      return numCPU.toFixed(2);
    } else {
      return numCPL.toFixed(2);
    }
  };

  const checkJudge = (CPK) => {
    const numCPK = parseFloat(CPK);
    if (isNaN(numCPK) || !isFinite(numCPK)) {
      return "-";
    }
    if (numCPK > 1.33) {
      return "OK";
    } else {
      return "NG";
    }
  };

  const handleDownloadChart = () => {
    return new Promise((resolve, reject) => {
      // รอให้ chart render เสร็จก่อน
      setTimeout(() => {
        const chartInstance = chartRef.current;
        if (chartInstance && chartInstance.canvas) {
          const base64Image = chartInstance.canvas.toDataURL("image/png");
          resolve(base64Image);
        } else {
          // ลองหา canvas จาก DOM
          const canvasElement = document.querySelector("canvas");
          if (canvasElement) {
            const base64Image = canvasElement.toDataURL("image/png");
            resolve(base64Image);
          } else {
            reject("Canvas is not available");
          }
        }
      }, 100);
    });
  };

  const handleExportNormalQT = async () => {
    if (!part || !question || reportData.length === 0) {
      console.log("Missing data:", { part, question, reportData });
      return;
    }
    if (selectedRows.length === 0) {
      alert("กรุณาเปิด Checkbox เลือกข้อมูลอย่างน้อย 1 รายการก่อนทำการ Export");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        "/templates/Xbar R Chart_app.xlsx?v=" + new Date().getTime(),
      );
      let arrayBuffer = await response.arrayBuffer();

      if (part.part_image) {
        try {
          const fullImageUrl = getImageUrl(part.part_image);
          //console.log("[Export Debug] part_image raw:", part.part_image);
          //console.log("[Export Debug] part_image full URL:", fullImageUrl);
          const imgRes = await fetch(fullImageUrl);
          const imgBlob = await imgRes.blob();
          const imgArrayBuffer = await imgBlob.arrayBuffer();
          arrayBuffer = await injectImageIfPlaceholderExists(
            arrayBuffer,
            imgArrayBuffer,
          );
        } catch (imgError) {
          //console.error("Could not override image for excel", imgError);
        }
      } else {
        //console.log("[Export Debug] part.part_image is empty/null:", part);
      }

      const workbook = await window.XlsxPopulate.fromDataAsync(arrayBuffer);
      const sheet = workbook.sheet(0);

      // console.log(
      //   "[Export Debug] part_code:",
      //   part.part_code,
      //   "part_name:",
      //   part.part_name,
      // );
      if (part.part_code) sheet.cell("C2").value(part.part_code);
      if (part.part_name) sheet.cell("O2").value(part.part_name);
      if (part.spec_max !== undefined)
        sheet.cell("D14").value(Number(part.spec_max));
      if (part.spec_min !== undefined)
        sheet.cell("F14").value(Number(part.spec_min));

      // Spec range text in merged A+B cells at row 19 and 31
      if (part.spec_min !== undefined && part.spec_max !== undefined) {
        const specText = `${Number(part.spec_min).toFixed(2)} - ${Number(part.spec_max).toFixed(2)}`;
        sheet.cell("A19").value(specText);
        sheet.cell("A31").value(specText);
      }

      // Customer → X2, Month → X3
      if (part.customer) sheet.cell("X2").value(part.customer);
      // Month from first selected data's date or current date range
      const selectedData = reportData.filter((item) =>
        selectedRows.includes(item.id),
      );
      if (selectedData.length > 0 && selectedData[0].date) {
        sheet
          .cell("X3")
          .value(dayjs(selectedData[0].date, "DD/MM/YYYY").format("MMMM YYYY"));
      }

      for (let row = 40; row <= 42; row++) {
        for (let col = 6; col <= 35; col++) {
          sheet.cell(row, col).value(null);
        }
      }

      selectedData.forEach((item, idx) => {
        const colNumber = 6 + idx;
        const actuals = item.sc.actual || [];
        if (actuals[0] !== undefined)
          sheet.cell(40, colNumber).value(Number(actuals[0]));
        if (actuals[1] !== undefined)
          sheet.cell(41, colNumber).value(Number(actuals[1]));
        if (actuals[2] !== undefined)
          sheet.cell(42, colNumber).value(Number(actuals[2]));

        // Row 51: Job No, Row 52: Date, Row 53: Time
        if (item.jobNo) sheet.cell(51, colNumber).value(item.jobNo);
        if (item.date) sheet.cell(52, colNumber).value(item.date);
        if (item.time) sheet.cell(53, colNumber).value(item.time);
      });

      // Machine No → O3 (use first selected item's machine)
      if (selectedData.length > 0 && selectedData[0].machineNo) {
        sheet.cell("O3").value(selectedData[0].machineNo);
      }

      const blob = await workbook.outputAsync();
      saveAs(blob, `Report_Xbar_${part.part_code || "Export"}.xlsx`);
    } catch (e) {
      console.error("Error in Download NormalQT Template:", e);
    }
    setLoading(false);
  };

  const handleExportSPC = async () => {
    console.log("export");
    const fileName = "namo";
    const workBook = XLSX.utils.book_new();
    const workSheet = XLSX.utils.json_to_sheet([
      {
        X: calX(dataAverage).toFixed(2),
        R: calR(dataRange).toFixed(2),
        USL: part.spec_max,
        LSL: part.spec_min,
        "d2 (n=3)": d2neq3,
        Sigma: calSigma(dataRange, d2neq3).toFixed(2),
        Cp: calCP(part.spec_max, part.spec_min, dataRange, d2neq3).toFixed(2),
        Cpu: calCPU(part.spec_max, dataAverage, dataRange, d2neq3).toFixed(2),
        Cpl: calCPL(dataAverage, part.spec_min, dataRange, d2neq3).toFixed(2),
        Cpk: calCPK(
          calCPU(part.spec_max, dataAverage, dataRange, d2neq3),
          calCPL(dataAverage, part.spec_min, dataRange, d2neq3),
        ),
        Judge: checkJudge(
          calCPK(
            calCPU(part.spec_max, dataAverage, dataRange, d2neq3),
            calCPL(dataAverage, part.spec_min, dataRange, d2neq3),
          ),
        ),
      },
    ]);
    XLSX.utils.book_append_sheet(workBook, workSheet, fileName);
    XLSX.writeFile(workBook, "Report SPC.xlsx");
  };

  useEffect(() => {
    findOnePart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {/* <pre>{JSON.stringify(part)}</pre> */}
      {/* <div className="bg-black w960 h-40 flex justify-center items-center">
      <div className="py-2 px-4 bg-white rounded-full hover:bg-yellow-300 transition">
        Sawanon Wattanasit
      </div>
      </div> */}
      <SimpleBackdrop open={loading} setOpen={setLoading} />

      <div className={`lg:flex lg:flex-row p-2  justify-center flex flex-col`}>
        {/* <div>{window.screen.availHeight}</div>
        <div>{window.screen.availWidth}</div> */}
        <div
          className={` bg-white rounded-md drop-shadow py-2 px-4 lg:mt-0 lg:basis-3/5 lg:m-1 flex flex-row`}
        >
          <div className={`basis-1/2 `}>
            <div className="flex">
              <div className={`basis-1/2 text-gray-500`}>Part name :</div>
              <div className={`basis-1/2 text-end`}>{part.part_name}</div>
            </div>
            <div className="flex mt-2">
              <div className={`basis-1/2 text-gray-500`}>Part No. :</div>
              <div className={`basis-1/2 text-end`}>{part.part_code}</div>
            </div>
            <div className="flex mt-2">
              <div className={`basis-1/2 text-gray-500`}>Characteristic :</div>
              <div className={`basis-1/2 text-end`}>{part.question_name}</div>
            </div>
            <div className="flex mt-2">
              <div className={`basis-1/2 text-gray-500`}>Specification :</div>
              <div className={`basis-1/2 text-end`}>
                {part.spec_min !== undefined &&
                  part.spec_min !== null &&
                  !isNaN(Number(part.spec_min)) && (
                    <span className={``}>{`(Min) ${Number(
                      part.spec_min,
                    ).toFixed(2)}`}</span>
                  )}
                {part.spec_max !== undefined &&
                  part.spec_max !== null &&
                  !isNaN(Number(part.spec_max)) && (
                    <span className={`ml-4`}>{`(Max) ${Number(
                      part.spec_max,
                    ).toFixed(2)}`}</span>
                  )}
              </div>
            </div>
          </div>
          <div className={`flex justify-center items-center basis-1/2`}>
            {part.part_image ? (
              <img
                src={getImageUrl(part.part_image)}
                alt="part"
                className=" object-contain h-[300px]"
              />
            ) : (
              <div
                style={{ width: "6rem", height: "6rem" }}
                className="bg-gray-100 flex items-center justify-center rounded-lg"
              >
                <NoPhotographyIcon />
              </div>
            )}
          </div>
        </div>
        <div
          className={` bg-white rounded-md drop-shadow py-2 px-4 mt-4 lg:mt-0 lg:basis-2/5 lg:m-1`}
        >
          <div className={`text-base text-center border-b py-1 font-bold`}>
            Control Limit
          </div>
          <TableControlLimit data={controlLimit[0]} partData={part} />
        </div>
      </div>
      <div className={`gap-4 mt-4 p-4 lg:flex`}>
        <div className="basis-3/5">
          <div className={`flex gap-4 items-end relative justify-center`}>
            {checkDate.error && (
              <div
                className={`bg-red-500 py-2 px-4 text-white absolute rounded-md -bottom-10`}
              >
                {checkDate.message}
              </div>
            )}
            <div className={`${startDate.error && `bg-red-300 rounded`}`}>
              <DateTime
                value={startDate.value}
                autoFocus={startDate.error}
                label={`Start date`}
                onChange={handleOnChangeStartDate}
              />
            </div>
            <div className={`${endDate.error && `bg-red-300 rounded`}`}>
              <DateTime
                value={endDate.value}
                autoFocus={endDate.error}
                label={`End date`}
                onChange={handleOnChangeEndDate}
              />
            </div>
            <div className="flex gap-2">
              <Button
                variant="contained"
                onClick={() => handleSubmitSearch(startDate, endDate)}
              >
                Search
              </Button>
              {reportData.length > 0 && (
                <Button variant="outlined" onClick={handleSelectFirst30}>
                  Select 30
                </Button>
              )}
            </div>
          </div>
          {reportData.length > 0 ? (
            <TableReport
              className={`mt-4`}
              data={reportData}
              headers={headers}
              selectedRows={selectedRows}
              onSelectAll={handleSelectAll}
              onSelectRow={handleSelectRow}
            />
          ) : (
            <div className={`text-2xl flex justify-center items-center h-80`}>
              No data
            </div>
          )}
        </div>
        <div className="basis-2/5">
          <div
            className={`bg-white drop-shadow rounded-md mt-4 lg:mt-0 lg:w-80 xl:w-full`}
          >
            <div
              className={`flex relative justify-end items-center text-base border-b p-1 font-bold`}
            >
              <div
                className={`absolute inset-0 flex justify-center items-center`}
              >
                Process Capability Studies
              </div>
              <Button
                className="bg-orangeCustom"
                variant="contained"
                onClick={handleExportNormalQT}
                sx={{ margin: 1, minWidth: "auto", padding: "8px" }}
              >
                <Download />
              </Button>
              <div
                className={`relative cursor-pointer m-1 text-white p-1 rounded-full bg-blue-500 hover:bg-white hover:text-blue-500 transition`}
                onClick={handleExportSPC}
              >
                <Download color="inherit" />
              </div>
            </div>
            <div className="flex xl:flex-col">
              <div
                className={`xl:text-center flex flex-col xl:flex-row basis-1/2 xl:mt-4`}
              >
                <div
                  className={`xl:border-b-0 pl-4 xl:pl-0 py-1  text-sm basis-1/6 border-b`}
                >
                  X
                </div>
                <div
                  className={`xl:border-b-0 pl-4 xl:pl-0 py-1  text-sm basis-1/6 border-b`}
                >
                  R
                </div>
                <div
                  className={`xl:border-b-0 pl-4 xl:pl-0 py-1  text-sm basis-1/6 border-b`}
                >
                  USL
                </div>
                <div
                  className={`xl:border-b-0 pl-4 xl:pl-0 py-1  text-sm basis-1/6 border-b`}
                >
                  LSL
                </div>
                <div
                  className={`xl:border-b-0 pl-4 xl:pl-0 py-1  text-sm basis-1/6 border-b`}
                >
                  d2 (n=3)
                </div>
                <div
                  className={`xl:border-b-0 pl-4 xl:pl-0 py-1  text-sm basis-1/6 border-b`}
                >
                  Sigma
                </div>
                <div
                  className={`xl:border-b-0 pl-4 xl:pl-0 py-1  text-sm basis-1/6 border-b`}
                >
                  Cp
                </div>
                <div
                  className={`xl:border-b-0 pl-4 xl:pl-0 py-1  text-sm basis-1/6 border-b`}
                >
                  Cpu
                </div>
                <div
                  className={`xl:border-b-0 pl-4 xl:pl-0 py-1  text-sm basis-1/6 border-b`}
                >
                  Cpl
                </div>
                <div
                  className={`xl:border-b-0 pl-4 xl:pl-0 py-1  text-sm basis-1/6 border-b`}
                >
                  Cpk
                </div>
                <div
                  className={`xl:border-b-0 pl-4 xl:pl-0 py-1  text-sm basis-1/6 border-b`}
                >
                  Judge
                </div>
              </div>
              <div className="xl:text-center lg:text-end flex flex-col xl:flex-row basis-1/2">
                <div className="xl:border-b-0 pr-4 xl:pr-0 py-1  text-sm basis-1/6 border-b">
                  {" "}
                  {/* X */}
                  {dataAverage.length > 0
                    ? calX(dataAverage).toFixed(2)
                    : "-"}
                </div>
                <div className="xl:border-b-0 pr-4 xl:pr-0 py-1  text-sm basis-1/6 border-b">
                  {" "}
                  {/* R */}
                  {dataRange.length > 0
                    ? calR(dataRange).toFixed(2)
                    : "-"}
                </div>
                <div className="xl:border-b-0 pr-4 xl:pr-0 py-1  text-sm basis-1/6 border-b">
                  {" "}
                  {/* USL */}
                  {part.spec_max !== undefined && part.spec_max !== null
                    ? part.spec_max
                    : "-"}
                </div>
                <div className="xl:border-b-0 pr-4 xl:pr-0 py-1  text-sm basis-1/6 border-b">
                  {" "}
                  {/* LSL */}
                  {part.spec_min !== undefined && part.spec_min !== null
                    ? part.spec_min
                    : "-"}
                </div>
                <div className="xl:border-b-0 pr-4 xl:pr-0 py-1  text-sm basis-1/6 border-b">
                  {" "}
                  {/* d2 (n=3) */}
                  {d2neq3}
                </div>
                <div className="xl:border-b-0 pr-4 xl:pr-0 py-1  text-sm basis-1/6 border-b">
                  {" "}
                  {/* Sigma */}
                  {dataRange.length > 0
                    ? calSigma(dataRange, d2neq3).toFixed(2)
                    : "-"}
                </div>
                <div className="xl:border-b-0 pr-4 xl:pr-0 py-1  text-sm basis-1/6 border-b">
                  {" "}
                  {/* Cp */}
                  {dataRange.length > 0 &&
                  part.spec_max !== undefined &&
                  part.spec_min !== undefined
                    ? calCP(
                        part.spec_max,
                        part.spec_min,
                        dataRange,
                        d2neq3,
                      ).toFixed(2)
                    : "-"}
                </div>
                <div className="xl:border-b-0 pr-4 xl:pr-0 py-1  text-sm basis-1/6 border-b">
                  {" "}
                  {/* Cpu */}
                  {dataRange.length > 0 &&
                  dataAverage.length > 0 &&
                  part.spec_max !== undefined
                    ? calCPU(
                        part.spec_max,
                        dataAverage,
                        dataRange,
                        d2neq3,
                      ).toFixed(2)
                    : "-"}
                </div>
                <div className="xl:border-b-0 pr-4 xl:pr-0 py-1  text-sm basis-1/6 border-b">
                  {" "}
                  {/* Cpl */}
                  {dataRange.length > 0 &&
                  dataAverage.length > 0 &&
                  part.spec_min !== undefined
                    ? calCPL(
                        dataAverage,
                        part.spec_min,
                        dataRange,
                        d2neq3,
                      ).toFixed(2)
                    : "-"}
                </div>
                <div className="xl:border-b-0 pr-4 xl:pr-0 py-1  text-sm basis-1/6 border-b">
                  {" "}
                  {/* Cpk */}
                  {dataRange.length > 0 && dataAverage.length > 0
                    ? calCPK(
                        calCPU(part.spec_max, dataAverage, dataRange, d2neq3),
                        calCPL(dataAverage, part.spec_min, dataRange, d2neq3),
                      )
                    : "-"}
                </div>
                <div className="xl:border-b-0 pr-4 xl:pr-0 py-1  text-sm basis-1/6 border-b">
                  {" "}
                  {/* Judge */}
                  {dataRange.length > 0 && dataAverage.length > 0
                    ? checkJudge(
                        calCPK(
                          calCPU(part.spec_max, dataAverage, dataRange, d2neq3),
                          calCPL(dataAverage, part.spec_min, dataRange, d2neq3),
                        ),
                      )
                    : "-"}
                </div>
              </div>
              {/* <div className="flex xl:flex-row flex-col justify-end xl:w-2/5 mt-4 xl:mt-0 xl:absolute xl:-bottom-16 xl:-right-36 2xl:-right-24">
                <div className={`mt-4 mr-4`}>
                  <Button
                    className="bg-colorMain hover:bg-orangeCustom"
                    variant="contained"
                    onClick={handleExportNormalQT}
                  >
                    Export Normal
                  </Button>
                </div>
              </div> */}
            </div>
          </div>
          <div className={`mt-4`}>
            <LineChart
              ref={chartRef}
              arrData={dataAverage}
              chartName={`X-bar`}
              dataSetName={`X`}
              controlLimit={xBar}
            />
            {/* <LineChart arrData={reportData} chartName={`X-bar`} /> */}
          </div>
          <div>
            <LineChart
              arrData={dataRange}
              chartName={`R-chart`}
              dataSetName={`R`}
              controlLimit={rChart}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerPath;
